import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Item from './todo-item';
export default class TodoList extends Component {
    static{
        template(`
		<section class="main">
			{{#if @todos.length}}
				{{#if this.canToggle}}
					<input
						id="toggle-all"
						class="toggle-all"
						type="checkbox"
						checked={{this.areViewableCompleted}}
						{{on "change" this.toggleAll}}
					/>
					<label for="toggle-all">Mark all as complete</label>
				{{/if}}
				<ul class="todo-list">
					{{#each @todos as |todo|}}
						<Item
							@todo={{todo}}
							@onStartEdit={{this.disableToggle}}
							@onEndEdit={{this.enableToggle}}
						/>
					{{/each}}
				</ul>
			{{/if}}
		</section>
	`, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    @service
    repo;
    @tracked
    canToggle = true;
    get areViewableCompleted() {
        return this.args.todos.filter((todo1)=>todo1.completed).length === this.args.todos.length;
    }
    toggleAll = ()=>{
        let allCompleted1 = this.areViewableCompleted;
        this.args.todos.forEach((todo1)=>(todo1.completed = !allCompleted1));
        this.repo.persist();
    };
    enableToggle = ()=>(this.canToggle = true);
    disableToggle = ()=>(this.canToggle = false);
}
